import DREMainPage from "../../../../components/Financial/DRE/DREMainPage";

const DREFranquia = () => (
  <DREMainPage title="DRE" endpoint="/dre" />
);

export default DREFranquia;
